import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
import Cache from '../cache/cache';

// 文章列表
export default async function ArtcleList(context: Context, params: CustomQuery): Promise<ApiResult> {
  // 获取缓存
  const cacheKey = 'ArtcleList_' + JSON.stringify(params);
  const cache = Cache.getCache(context, cacheKey);
  if (cache) {
    return cache;
  }

  const url = new URL('/mall/article/new_list', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);

  // 设置缓存
  Cache.setCache(context, cacheKey, res);
  return res;
}
